import React from 'react';
import { TextInput, required, SelectInput, DateInput } from 'react-admin';
import PropTypes from 'prop-types';

import { Grid } from '@material-ui/core';

const CourseForm = ({ nameLabel, statusLabel, status }) => (
  <Grid container spacing={3}>
    <Grid item xs={12} sm={6} md={6}>
      <TextInput
        source="name"
        label={nameLabel}
        fullWidth
        validate={required()}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={6}>
      <SelectInput
        source="status"
        defaultValue={status[0].id}
        choices={status}
        label={statusLabel}
        fullWidth
        validate={required()}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={6}>
      <DateInput
        source="startDate"
        label={statusLabel}
        fullWidth
        validate={required()}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={6}>
      <DateInput
        source="endDate"
        label={statusLabel}
        fullWidth
        validate={required()}
      />
    </Grid>
  </Grid>
);

CourseForm.propTypes = {
  nameLabel: PropTypes.string.isRequired,
  statusLabel: PropTypes.string.isRequired,
  status: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ).isRequired,
};

export default CourseForm;
